module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FQrbs4/tc-custom/9781646565276.jpg?1723374917071",
      "alt": "This image is the cover for the book Forget Me Not"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forget Me Not\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jensen Morris is financially stable, and has been dating Milo Hawkins for more than fifteen years. Once in a while he feels as if something is missing, but he's probably imagining things."), _c('br'), _c('br'), _vm._v("Milo is a witch who works as an exorcist. His parents died many years ago, and his foster parents were murdered by demons a few years later. Milo thought he must be cursed and would never find stability and happiness until Jensen came along. Since then, Milo's life has been wonderful. Then Mariana, the leader of the coven of witches Milo belongs to, has visions of a nine-tailed fox and a trail of forget-me-not flowers."), _c('br'), _c('br'), _vm._v("Kenta is awakened from a deep trance when he senses a spark of magic from someone who has ventured too close to his well-concealed cave. The first time he sees Jensen and Milo, something about them feels familiar, but he doesn't know what. Something inside him is blocking his memory. However, they make him feel safe."), _c('br'), _c('br'), _vm._v("Can the three men find some joy and stability with one another when danger lurks around the corner?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Casper Graham\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0